export const ROLE_COLORS = {
  fields: "#dc2626",
  cover: "#2563eb",
  relay: "#7c3aed",
  backup: "#0d9488",
  hold: "#4b5563",
};

export const LEGEND = [
  { key: "fields", label: "Fields ball" },
  { key: "cover", label: "Covers base" },
  { key: "relay", label: "Cutoff / relay" },
  { key: "backup", label: "Backs up" },
  { key: "hold", label: "Holds" },
];

export const roleOf = (job) => {
  if (job === "fields") return "fields";
  if (job?.startsWith("cover")) return "cover";
  if (job === "cutoff" || job === "relay") return "relay";
  if (job === "backup") return "backup";
  return "hold";
};

export const RUNNER_COLOR = "#ea580c";
